import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-periodi-dettaglio',
  templateUrl: './periodi-dettaglio.component.html',
  styleUrls: ['./periodi-dettaglio.component.css']
})
export class PeriodiDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  public isEdit: number = 0;

  constructor(public dialogRef: MatDialogRef<PeriodiDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Periodo'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      Descrizione: [null],
      Visibile: [1]
    })


    if (this.data.sValore != "0") {
      this.getDettaglio(this.data.sValore)
     // console.log('svalore modale', this.data.sValore)
      this.isEdit = 0;
    } else {
      this.titolo = this.titolo + ' - Inserimento ';
      this.isEdit = 1;
    }
    

  }


  getDettaglio(sValore: string) {
    this.srvUtilita.getObj('Utenti/GetPeriodiDettaglio?sDescrizione=' + sValore).subscribe((res: any) => {
      this.objdettaglio = res
      //console.log(res, 'res')
      this.frmInserimento.patchValue(this.objdettaglio)
      this.titolo = this.titolo + ": " + this.objdettaglio.Descrizione
    })
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.Visibile == true) {
      objInserimento.Visibile = 1
    } else {
      objInserimento.Visibile = 0
    }

    this.srvUtilita.postObj('Utenti/PostPeriodi', objInserimento).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}
